import { Assessment } from '@mui/icons-material';
import React, { CSSProperties } from 'react';

const ProjectPlanningIcon = (props: { style?: CSSProperties }) => {
  return <Assessment style={{ transform: 'rotate(90deg)', ...props.style }} />;
};

export default ProjectPlanningIcon;
